"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartialSelectorProcessor = void 0;
const tslib_1 = require("tslib");
const lodash_clonedeep_1 = tslib_1.__importDefault(require("lodash.clonedeep"));
const Selector_1 = require("../../Form/Selector/Selector");
class PartialSelectorProcessor {
    static process(def, prefix, excludedKeys = []) {
        return PartialSelectorProcessor.parse((0, lodash_clonedeep_1.default)(def), prefix, excludedKeys);
    }
    static parse(def, prefix, excludedKeys) {
        for (const [key, val] of Object.entries(def)) {
            if (excludedKeys.includes(key)) {
                continue;
            }
            const valType = typeof val;
            if (valType === "string" && val.startsWith(Selector_1.Selector.separator)) {
                def[key] = `${prefix}${val}`;
            }
            else if (val && valType === "object") {
                def[key] = PartialSelectorProcessor.parse(val, prefix, excludedKeys);
            }
        }
        return def;
    }
}
exports.PartialSelectorProcessor = PartialSelectorProcessor;
